import type { KpiOwnerDirectory } from "@playbookai/kpi-feature";
import { listAllDirectoryGroups } from "./people-directory-api.js";

/**
 * Build the KPI Manager's owner directory (PB-94) from the tenant people
 * directory (PB-138). The KPI feature package stays source-agnostic — the shell
 * (composition root) supplies this.
 *
 * Only the directory groups are left here: the owner fields search, and name
 * owners through, the shell's `PeopleSource` (assign-person consistency).
 */
export function createKpiOwnerDirectory(): KpiOwnerDirectory {
  return {
    // Groups narrow the picker. An empty list is the ordinary answer for a
    // tenant without GroupMember.Read.All, and the picker then renders no
    // filter rather than an empty control.
    loadGroups: async (signal) => {
      const groups = await listAllDirectoryGroups(signal);
      return groups.map((group) => ({
        id: group.groupId,
        name: group.displayName,
      }));
    },
  };
}
